import React, { createContext, useCallback, useContext, useState } from 'react';
import Toast from './Toast';
import { View, StyleSheet, Platform } from 'react-native';
import ReactDOM from 'react-dom';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

const ToastContainer = ({ children }) => {
  if (Platform.OS === 'web') {
    // Create a portal for web to ensure toasts are rendered at the root level
    return ReactDOM.createPortal(
      <View style={[styles.toastContainer, styles.webToastContainer]}>
        {children}
      </View>,
      document.body
    );
  }

  return (
    <View style={[styles.toastContainer, styles.nativeToastContainer]}>
      {children}
    </View>
  );
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const toast = useCallback((toastProps) => {
    const id = Math.random().toString(36).substr(2, 9);
    setToasts((prevToasts) => [...prevToasts, { ...toastProps, id }]);
  }, []);

  const dismissToast = useCallback((id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  }, []);

  return (
    <>
      <ToastContext.Provider value={{ toast, dismissToast }}>
        {children}
      </ToastContext.Provider>
      <ToastContainer>
        {toasts.map((toast, index) => (
          <Toast
            key={toast.id}
            {...toast}
            style={{ bottom: (toasts.length - 1 - index) * 70 + (Platform.OS === 'ios' ? 50 : 30) }} // Stack toasts from bottom up
            onClose={() => dismissToast(toast.id)}
          />
        ))}
      </ToastContainer>
    </>
  );
};

const styles = StyleSheet.create({
  toastContainer: {
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    alignItems: 'center',
    pointerEvents: 'box-none',
    zIndex: 2147483647,
  },
  webToastContainer: {
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '30px 0',
  },
  nativeToastContainer: {
    bottom: Platform.OS === 'ios' ? 50 : 30,
  }
}); 